import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { IRootThunkDispatch, IRootState } from "../../redux/store";
import { DataGrid, GridColDef } from "@mui/x-data-grid";
import { Button, Grid } from "@mui/material";
import { EditNote } from "@mui/icons-material";
import FormDialog from "../common/FormDialog";
import moment from "moment";
import { CleaningDetailRouteList } from "../../redux/cleaning/state";
import { OpenLoadingBarThunk } from "../../redux/common/isLoading/thunk";
import {
    axiosGet,
    axiosPutWithJson,
} from "../../util/axios";
import {
    OpenSnackBarWithResultFail,
    OpenSnackBarWithResultSuccess,
} from "../../redux/common/snackBar/thunk";
import {
    initCleaningDetailRoutePhotoThunk,
    selectedCleaningDetailRouteThunk,
    updateCleaningDetailThunk,
} from "../../redux/cleaning/thunk";
import CleaningDetailImage from "./CleaningDetailImage";
import styles from "./CleaningDetailRoute.module.css";
import { isGovernemnt, isSuperAdmin } from "../../util/form/form";
import EditAttendance from "../common/EditAttendance";
import { ButtonTextGrid } from "../..";

function CleaningDetailRoute() {
    const dispatch = useDispatch<IRootThunkDispatch>();
    const { user } = useSelector((state: IRootState) => state.userAuth);
    const isGovernmentRole = isGovernemnt(user?.token?.role_id as number);
    const isSuperAdminRole = isSuperAdmin(user?.token?.role_id as number);
    const [editDialog, setEditDialog] = useState<boolean>(false);
    const { cleaningDetailRouteList, selectedCleaningDetail, binInfo } =
        useSelector((state: IRootState) => state.cleaningState);

    const [openPhotoDialog, setOpenPhotoDialog] = useState<boolean>(false);
    const [selectedCleaningId, setSelectedCleaningId] = useState<number>(0);
    const [selectedCleaningDate, setSelectedCleaningDate] = useState<
        moment.Moment|null|string
    >(null);
    const [selectedBinId, setSelectedBinId] = useState<number | undefined>(undefined);
    const [selectedContractId, setSelectedContractId] = useState<number | undefined>(undefined);

    function handleCloseDialog() {
        setOpenPhotoDialog(false);
        setEditDialog(false);
    }

    async function handleImageClick(
        cleaningDetailRouteList: CleaningDetailRouteList
    ) {
        dispatch(OpenLoadingBarThunk(true));
        setSelectedCleaningId(cleaningDetailRouteList.cleaning_id);
        setSelectedCleaningDate(cleaningDetailRouteList.update_date as string);
        setSelectedBinId(cleaningDetailRouteList.bin_id);
        setSelectedContractId(cleaningDetailRouteList.contract_id);
        const result = await axiosGet(
            `/api/cleaning/date/cleaningImage?cleaning_id=${cleaningDetailRouteList.cleaning_id}`
        );
        dispatch(OpenLoadingBarThunk(false));
        if (result.data.success) {
            dispatch(
                initCleaningDetailRoutePhotoThunk(
                    result.data.CleaningDetailImage
                )
            );
            setOpenPhotoDialog(true);
        } else {
            dispatch(OpenSnackBarWithResultFail("未能取得清潔相片"));
        }
    }

    async function handleSubmitEdit() {
        const data: CleaningDetailRouteList = {
            cleaning_id: selectedCleaningDetail.cleaning_id,
            attendance_date: moment(selectedCleaningDetail.attendance_date).valueOf().toString(),
            update_date: moment(selectedCleaningDetail.update_date).valueOf().toString(),
            bin_full_name: selectedCleaningDetail.bin_full_name,
            bin_id: binInfo?.value ? binInfo?.value : 0,
            attendance_place: binInfo?.label ? binInfo?.label : "",
            cleaning_detail_route_id:selectedCleaningDetail.cleaning_detail_route_id,
            sequence: selectedCleaningDetail.sequence,
            time_start: selectedCleaningDetail.time_start,
            time_end: selectedCleaningDetail.time_end,
            create_date:selectedCleaningDetail.create_date,
            people_counter_number: selectedCleaningDetail.people_counter_number

        };

        // dispatch(OpenLoadingBarThunk(true));
        const result = await axiosPutWithJson(
            `api/cleaning/attendance/${data.cleaning_id}`,
            data
        );
        if (result.data.success) {
            dispatch(OpenLoadingBarThunk(false));
            dispatch(OpenSnackBarWithResultSuccess(result.data.message));
            dispatch(updateCleaningDetailThunk(cleaningDetailRouteList, data));
            setEditDialog(false);
        } else {
            dispatch(OpenSnackBarWithResultFail("未能更改清潔打卡等資料"));
        }
    }

    function handleClickEditButton(
        cleaningAttentionInfo: CleaningDetailRouteList
    ) {
        setEditDialog(true);
        console.log('selectedCleaningDetail',selectedCleaningDetail)
        dispatch(selectedCleaningDetailRouteThunk(cleaningAttentionInfo));
    }

    const columns: GridColDef[] = [
        {
            field: "cleaning_detail_route_id",
            headerName: "具體編號",
            flex: 1,
            renderCell: (data) => (
                <div
                    className={
                        data.row.is_adhoc === 1 ? styles.isAdditonal : ""
                    }
                >
                    {data.value}
                </div>
            ),
        },
        {
            field: "sequence",
            headerName: "清潔次序",
            flex: 1,
        },
        {
            field: "bin_full_name",
            headerName: "桶名稱",
            flex: 3,
        },
        {
            field: "attendance_date",
            headerName: "打卡時間",
            flex: 2,
            renderCell: (data) => (
                
             <div>
                    {data.value
                        ?new Date(parseInt(data.value)).toLocaleString()
                        : null}
                </div>
            ),
        },
        {
            field: "attendance_place",
            headerName: "打卡地點",
            flex: 2,
        },
        {
            field: "submit_date",
            headerName: "完成時間",
            flex: 2,
            renderCell: (data) => (
                <div>
                    {data.value
                        ?new Date(parseInt(data.value)).toLocaleString()
                        : null}
                </div>
            ),
        },

           {
            field: "people_counter_number",
            headerName: "人流",
            flex: 1,
        },
        {
            field: "action",
            headerName: "相片詳情",
            flex: 1,
            renderCell: (data) => (
                <div>
                    {data.row.update_date ? (
                        <Button
                            variant="contained"
                            onClick={() => handleImageClick(data.row)}
                        >
                            <ButtonTextGrid>
                            <EditNote />
                            <Grid>相片</Grid>
                            </ButtonTextGrid>

                        </Button>
                    ) : (
                        <></>
                    )}
                </div>
            ),
        },

        {
            field: "edit",
            headerName: "修改紀錄",
            flex: 2,
            renderCell: (data) => (
                <div>
                    <Button
                        variant="contained"
                        onClick={() => handleClickEditButton(data.row)}
                        
                    >
    <ButtonTextGrid>
                        <EditNote />
                        <Grid>更改</Grid>
    </ButtonTextGrid>

                    </Button>
                </div>
            ),
        },
    ];

    return (
        <div>
            <div className={styles.demoOuterContainer}>
                <div className={styles.demoContainer}></div>
                <div>為司機頂更地點</div>
            </div>

            <div style={{ height: "900px", width: "100%" }}>
                <DataGrid
                    rows={cleaningDetailRouteList || []}
                    columns={columns}
                    initialState={{
                        pagination: {
                            paginationModel: { page: 0, pageSize: 30 },
                        },
                    }}
                    pageSizeOptions={[5, 10]}
                    checkboxSelection
                    getRowId={(row) => `${row.cleaning_detail_route_id}_${row.bin_id}`}
              
                />
            </div>

            <FormDialog
                title="更改收集情況"
                open={editDialog}
                handleClose={handleCloseDialog}
                handleSubmit={handleSubmitEdit}
                size="lg"
            >
                <EditAttendance mode="Cleaning" />
            </FormDialog>

            <FormDialog
                title="相片情況 (點擊放大)"
                open={openPhotoDialog}
                handleClose={handleCloseDialog}
                size="lg"
            >
                <CleaningDetailImage
                    selectedCleaningId={selectedCleaningId}
                    selectedCleaningDate={selectedCleaningDate}
                    handleClose={handleCloseDialog}
                    binId={selectedBinId}
                    contractId={selectedContractId}
                />
            </FormDialog>
        </div>
    );
}

export default CleaningDetailRoute;
